import gql from 'graphql-tag';

import { PLEX_DOMAIN_FRAGMENT } from '../fragments/Plex/plexDomainSummary';
import { DomainPlexesQueryVariables } from '../gen/types';

// TODO rollback limit back to 30 when implementing search on the backend side
export const DOMAIN_PLEXES_QUERY = gql`
  query DomainPlexes($cursor: String) {
    currentUser {
      id
      domain {
        id
        plexes(cursor: $cursor, limit: 60) {
          items {
            ...plexDomainSummary
          }
          nextCursor
        }
      }
    }
  }

  ${PLEX_DOMAIN_FRAGMENT}
`;

export const DOMAIN_PLEXES_INITIAL_QUERY_VARIABLES: DomainPlexesQueryVariables = {};

export { useDomainPlexesQuery } from '../gen/types';
